
import card1 from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card1.png";
import card2 from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card2.png";
import card3 from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card3.png";
import footer from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card.png"
import { useScrollAnim } from "../../hook/useScrollAnim";

export default function Card() {
  const containerRef = useScrollAnim({
    selector: "div, img",
    threshold: 0.3,
    once: true,
  });
  return (
    <>
      <div className="GaFa-cards up" ref={containerRef}>
        <div>
          <img src={card3} alt="" />
        </div>
        <div>
          <img src={card2} alt="" />
        </div>
        <div>
          <img src={card1} alt="" />
        </div>
      </div>
      <div className="GaFa-card">
        <img className="img-footer" src={footer} alt="" />
      </div>
    </>
  );
}
